module.exports = __webpack_public_path__ + "img/type1.d0f74266.png";